import * as React from "react";
import { addDays, addYears, stripToDay } from "../../../../../../../../react-core/utils/date";
import { NumberTextBoxEditor } from "../../../../../../../../react-core/Html/NumberTextBoxEditor";
import { MoneyHelper } from "../../../../../../../Shared/Common/MoneyHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DatePicker } from "../../../../../../../../react-core/Datepicker/DatePicker";
import { datePickerOptions } from "../../../../Common/Resource/Contents";
import { PensionApply } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionApply";
import {
    TransferOrDrawdown,
    nbSippIncomePaymentDetailsLabels,
    nbSippIncomePaymentDetailsMessages,
} from "../../../Resource/Contents";

import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";

interface ITransferTotalsProps extends IProcessComponentProps {
    data: PensionApply;
    cappedTransfers: Array<TransferOrDrawdown>;
    flexiTransfers: Array<TransferOrDrawdown>;
    onChange: (changes) => void;
}
interface ITransferTotalsState {}

export class TransferTotals extends ProcessComponent<ITransferTotalsProps, ITransferTotalsState> {
    constructor(props: any) {
        super(props);
    }

    private flexiTotals(): number {
        const { flexiTransfers } = this.props;
        return flexiTransfers.reduce((sum, transfer) => {
            const amount: number = transfer.IncomePaymentDetails.GrossIncomePerPayment?.Amount || 0;
            return sum + amount;
        }, 0);
    }

    private isShowFlexiIncome() {
        const { data, cappedTransfers, flexiTransfers } = this.props;

        // Specific arrangement = false
        if (data?.DrawdownModel?.Income?.TargetSpecificArrangements !== true) {
            // standard algorithm
            // need check if there's capped transfer, if yes, then hide flexi review section - false
            return cappedTransfers.length == 0;
        } else {
            // specific algorithm
            // need to check if income is paied from flexi arrangement, if yes, then show flexi review section - true
            let flag = false;
            flexiTransfers.forEach((v: TransferOrDrawdown) => {
                if (v?.IncomePaymentDetails?.GrossIncomePerPayment?.Amount > 0) {
                    flag = true;
                }
            });
            return flag;
        }
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        const yearFromNow = () => {
            const result = stripToDay(addYears(new Date(Date.now()), 1));
            if (result.getDate() > 28) {
                result.setDate(28);
            }
            return result;
        };
        return (
            <>
                {this.isShowFlexiIncome() && (
                    <>
                        <div className="row">
                            <div className="col-4">
                                <DatePicker
                                    selected={
                                        data?.DrawdownModel?.Income?.FlexiIncomeReviewDate
                                            ? JsonDateParser.toDateNoOffset(
                                                  data?.DrawdownModel?.Income?.FlexiIncomeReviewDate
                                              )
                                            : yearFromNow()
                                    }
                                    label={nbSippIncomePaymentDetailsLabels.nextFlexiReviewDate}
                                    {...datePickerOptions}
                                    alwaysValidateOnUpdate={true}
                                    atMost={{
                                        errorMessage: nbSippIncomePaymentDetailsMessages.nextFlexiReviewDateUnder,
                                        value: stripToDay(addYears(new Date(Date.now()), 3)),
                                    }}
                                    moreThan={{
                                        errorMessage: nbSippIncomePaymentDetailsMessages.nextFlexiReviewDateUnder,
                                        value: stripToDay(addDays(new Date(Date.now()), 20)),
                                    }}
                                    filterDate={{
                                        errorMessage: nbSippIncomePaymentDetailsMessages.dateOver28,
                                        validator: (v) => v.getDate() <= 28,
                                    }}
                                    required={nbSippIncomePaymentDetailsMessages.nextFlexiReviewDateRequired}
                                    onChange={(v) => {
                                        const changes = {
                                            ...data?.DrawdownModel?.Income,
                                            ...{ FlexiIncomeReviewDate: JsonDateParser.toJsonDateNoOffset(v) },
                                        };
                                        this.onDataChange(onChange, changes, data, "Income");
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <NumberTextBoxEditor
                                    value={
                                        data.DrawdownModel?.Income?.FrequencyFlexiIncomeReview
                                            ? data.DrawdownModel?.Income?.FrequencyFlexiIncomeReview
                                            : 12
                                    }
                                    moreThan={{
                                        errorMessage:
                                            nbSippIncomePaymentDetailsMessages.frequencyOfFlexiIncomeReviewUnderOver,
                                        value: 0,
                                    }}
                                    atMost={{
                                        errorMessage:
                                            nbSippIncomePaymentDetailsMessages.frequencyOfFlexiIncomeReviewUnderOver,
                                        value: 60,
                                    }}
                                    label={nbSippIncomePaymentDetailsLabels.frequencyOfFlexiIncomeReview}
                                    onChange={(v) => {
                                        const changes = {
                                            ...data.DrawdownModel.Income,
                                            ...{ FrequencyFlexiIncomeReview: v },
                                        };
                                        this.onDataChange(onChange, changes, data, "Income");
                                    }}
                                />
                            </div>
                        </div>
                        <hr />
                    </>
                )}
            </>
        );
    }
}

export default TransferTotals;
